/**
 * BOX 型（ページ内の入口バナー → クリックでモーダル）の設定。
 * 埋め込み側（BoxEntryBanner）と管理画面側（BoxSettingsModal）で共有する。
 */

/**
 * 入口バナーに重ねる見出しの既定文言。
 *
 * 'INTERACTIVE MOVIE' はカテゴリ名であって見出しではなく、「なぜ見るのか」を語れていない
 * （カテゴリ表記はバナー上部のラベルが担う）。BOX 型は採用インタビューだけでなくクイズや
 * 商談用途にも使われるため、用途に寄らず「選べる」ことだけが伝わる文言にする。
 */
export const DEFAULT_BOX_ENTRY_TITLE = '選ぶたびに、続きが変わる動画'

/** 入口バナーのボタン文言の既定値 */
export const DEFAULT_BOX_ENTRY_CTA_TEXT = 'クリックで体験する'

/** 表示崩れを防ぐための最大文字数 */
export const BOX_ENTRY_TITLE_MAX_LENGTH = 40
export const BOX_ENTRY_CTA_TEXT_MAX_LENGTH = 20

/** BOX 型の scenario.config に保持する設定 */
export type BoxConfig = {
  /** 入口バナーの見出し（例: リアル店舗経営シミュレーション） */
  boxEntryTitle?: string
  /** 入口バナーのボタン文言 */
  boxEntryCtaText?: string
}
